import React from "react";
import { MapPinned, Save, Star, X } from "lucide-react";

export default function SavedAddressBar({ which, title = "Saved addresses", list, canSave, onUse, onSave, onSetDefault, onDelete }) {
  return (
    <div className="rounded-md border border-dashed border-border p-2.5" data-testid={`saved-addresses-${which}`}>
      <div className="mb-1.5 flex items-center justify-between">
        <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <MapPinned className="h-3.5 w-3.5 text-kilted-gold" /> {title}
        </p>
        <button type="button" onClick={onSave} disabled={!canSave} data-testid={`save-address-${which}`}
          className="flex items-center gap-1 text-xs font-medium text-kilted-green hover:underline disabled:opacity-40">
          <Save className="h-3.5 w-3.5" /> Save this
        </button>
      </div>
      {list.length === 0 ? (
        <p className="text-xs text-muted-foreground">{which === "dropoff" ? "No saved recipients yet — pick a drop-off above and tap \"Save this\" for one-tap reuse." : "No saved senders yet — pick an address above and tap \"Save this\" to reuse it later."}</p>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          {list.map((a) => (
            <div key={a.id} className="flex items-center gap-1 rounded-full border border-kilted-green/30 bg-white py-0.5 pl-2.5 pr-1 text-xs">
              <button type="button" onClick={() => onUse(a)} data-testid={`use-saved-address-${which}-${a.id}`} className="font-medium text-kilted-green hover:underline">
                {a.label}
              </button>
              {which === "pickup" && (
                <button type="button" onClick={() => onSetDefault(a.id)} title="Set as default sender" data-testid={`set-default-sender-${a.id}`}
                  className="text-muted-foreground hover:text-kilted-gold">
                  <Star className={`h-3 w-3 ${a.is_default_pickup ? "fill-kilted-gold text-kilted-gold" : ""}`} />
                </button>
              )}
              <button type="button" onClick={() => onDelete(a.id)} data-testid={`delete-saved-address-${which}-${a.id}`} className="text-muted-foreground hover:text-red-600">
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
